import { createFileRoute } from '@tanstack/react-router'
import { object, optional, parse, string } from 'valibot'
import node, {
  type explorerPageQuery,
} from '#gen/relay/explorerPageQuery.graphql'
import { ErrorHandler } from '#lib/errors/errors'
import { lazyLoadedComponent } from '#lib/routing/lazy-loaded-component'

const SearchParamsSchema = object({
  initializeOperation: optional(string()),
})

export const Route = createFileRoute(
  '/_dashboard/$account/graphql/$graph/branches/$branch/explorer',
)({
  staticData: { title: '[graph] - Explorer' },
  validateSearch(search) {
    return parse(SearchParamsSchema, search)
  },
  errorComponent: ErrorHandler,
  loader({ context, params }) {
    return context.preload<explorerPageQuery>(node, params)
  },
  component: lazyLoadedComponent(
    () => import('#app/pages/branch/explorer/explorer-page'),
    'ExplorerPage',
  ),
})
